import { PersonAddressObject, ServiceGridItemObject } from '@it2go/types';
import { ServiceFormEnum } from '../../../../../../types/src/services/enum/service-form.enum';
import { dateifyOrNow } from '../../../modules/shared/helpers/date.helper';
import { getValid } from '@libs/shared/utils/get-valid';

/**
 * Returns services for which is "provided operations reports" allowed.
 * @param services - list of services to check, should contain form and serviceType object containing settings string
 */
export function servicesWithAllowedProvidedOperationsReports(services: ServiceGridItemObject[]) {
    return services.filter((service) => {
        const settings = JSON.parse(service.serviceType.settings || '{}');

        // Osobní asistence, Pečovatelská služba, Podpora samostatného bydlení, Odlehčovací služby
        return service.form.includes(ServiceFormEnum.FIELD)
            && ['39', '40', '43', '44'].includes(settings?.law || '');
    });
}

export function getValidAddress(addresses: PersonAddressObject[]) {
    const orderedAddresses = [...addresses]
        .sort((a: PersonAddressObject, b: PersonAddressObject) => dateifyOrNow(a.validFrom).getTime() > dateifyOrNow(b.validFrom).getTime() ? -1 : 1);
    return getValid(orderedAddresses);
}
